var _defs, _path, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    zoomAndPan: "magnify",
    viewBox: "0 0 33.75 33.749998",
    height: 45,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e7917fb260"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 33.5 0 L 33.5 33.5 L 0 33.5 Z M 0 0 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 13.621094 20.898438 L 20.933594 16.605469 L 13.621094 12.3125 Z M 13.621094 20.898438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7917fb260)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 35.441406 -5.738281 L -2.25 -5.738281 C -4.175781 -5.738281 -5.738281 -4.175781 -5.738281 -2.25 L -5.738281 35.441406 C -5.738281 37.367188 -4.175781 38.929688 -2.25 38.929688 L 35.441406 38.929688 C 37.367188 38.929688 38.929688 37.367188 38.929688 35.441406 L 38.929688 -2.25 C 38.929688 -4.175781 37.367188 -5.738281 35.441406 -5.738281 Z M 27.761719 20.589844 C 27.761719 24.4375 23.914062 24.4375 23.914062 24.4375 L 9.277344 24.4375 C 5.429688 24.4375 5.429688 20.589844 5.429688 20.589844 L 5.429688 12.609375 C 5.429688 8.761719 9.277344 8.761719 9.277344 8.761719 L 23.914062 8.761719 C 27.761719 8.761719 27.761719 12.609375 27.761719 12.609375 Z M 27.761719 20.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a99899998ed1093718caa101053168a0.svg";
export { ForwardRef as ReactComponent };